import { cliente } from '@/lib/cliente';
import type { PeriodoMaqSel } from '@/lib/cliente';
import { useQuery } from '@tanstack/react-query';

/**
 * Movimientos de uso de una máquina para un canal (drill-down de Ingreso
 * Partes / Ingreso Recursos en Análisis General). `habilitado=false` evita
 * pedir mientras el drawer está cerrado.
 */
export function useMaquinariaMovimientos(
  maquina: string | null,
  origenUso: 'PARTE_TRABAJO' | 'ASSEMBLY' | null,
  periodoMaq?: PeriodoMaqSel,
) {
  return useQuery({
    queryKey: ['maquinaria-movimientos', maquina, origenUso, periodoMaq],
    queryFn: () => cliente.maquinaria.movimientos(maquina!, origenUso!, periodoMaq),
    enabled: !!maquina && !!origenUso,
  });
}
